import { gql } from '@apollo/client';

export const GET_HOVERCARD_PROFILE = gql`
  query getHovercardProfile($userId: String!) {
    getHovercardProfile(userId: $userId) {
      userId
      username
      displayName
      avatar
      bio
      followerCount
      followingCount
      isFollowedByViewer
      reputationOverall
      reputationVouchBoost
      reputationDomains
    }
  }
`;
